import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncPriest({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/priest"));
  console.log("Loading", AsyncPriest.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncPriest;
